<p-confirmDialog />
<p-card class="p-card" header="Invoices">
  <p-table
    #dataTable
    stripedRows
    [value]="invoices"
    [expandedRowKeys]="expandedRows"
    (onRowExpand)="onRowExpand($event)"
    (onRowCollapse)="onRowCollapse($event)"
    dataKey="id"
    responsiveLayout="scroll"
    selectionMode="single"
    [(selection)]="selectedInvoice">
    <ng-template #emptymessage>
      <tr>
        <td colspan="7">No invoices found.</td>
      </tr>
    </ng-template>

    <!-- Table Header -->
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th style="width: 3rem"></th>
        <th>Invoice #</th>
        <th>Invoice Date</th>
        <th>Due Date</th>
        <th>Period</th>
        <th>Amount</th>
        <th>Status</th>
        <th></th>
      </tr>
    </ng-template>

    <!-- Table Body -->
    <ng-template pTemplate="body" let-rowData let-expanded="expanded">
      <tr [pSelectableRow]="rowData">
        <td>
          <button
            type="button"
            pButton
            pRipple
            [pRowToggler]="rowData"
            class="p-button-text p-button-rounded p-button-plain"
            [icon]="
              expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'
            "></button>
        </td>
        <td>
          <a
            *ngIf="rowData.id"
            [routerLink]="['/admin/invoices/view', rowData.id]"
            class="text-blue-600 hover:underline">
            {{ rowData.invoice_number }}
          </a>
          <span *ngIf="!rowData.id">
            {{ rowData.invoice_number }}
          </span>
        </td>
        <td>{{ rowData.createdAt | date }}</td>
        <td>{{ rowData.due_date | date }}</td>
        <td>{{ rowData.lines?.data[0]?.period_start | date }}</td>
        <td>{{ rowData.including_tax | currency : "USD" }}</td>
        <td>
          <span
            [ngClass]="
              rowData.status === 'PAID'
                ? 'green'
                : rowData.status === 'Pending'
                ? 'orange'
                : 'red'
            ">
            {{ rowData.status }}
          </span>
        </td>
        <td style="text-align: right">
          <p-button
            (click)="selectedInvoice = rowData; menu.toggle($event)"
            [icon]="isSubLoading ? 'pi pi-spin pi-spinner' : 'pi pi-ellipsis-v'" />
        </td>
      </tr>
    </ng-template>
    <ng-template #expandedrow let-rowData>
      <tr>
        <td colspan="8">
          <div class="p-4">
            <p-table [value]="rowData.lines?.data">
              <ng-template pTemplate="header">
                <tr>
                  <th>Line Type</th>
                  <th>Description</th>
                  <th class="text-right">Period Start</th>
                  <th class="text-right">Period End</th>
                  <th class="text-right">Quantity</th>
                  <th class="text-right">Unit Amount</th>
                  <th class="text-right">Discount</th>
                  <th class="text-right">Amount</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-lineData>
                <tr>
                  <td>{{ lineData.line_type }}</td>
                  <td>{{ lineData.subscription.name }}</td>
                  <td class="text-right">
                    {{ lineData.period_start | date : "mediumDate" }}
                  </td>
                  <td class="text-right">
                    {{ lineData.period_end | date : "mediumDate" }}
                  </td>
                  <td class="text-right">{{ lineData.quantity }}</td>
                  <td class="text-right">
                    {{ lineData.unit_price | currency : "USD" }}
                  </td>
                  <td class="text-right">
                    {{ lineData.discount_total | currency : "USD" }}
                  </td>
                  <td class="text-right">
                    {{ lineData.line_total | currency : "USD" }}
                  </td>
                </tr>
              </ng-template>
              <ng-template #emptymessage>
                <tr>
                  <td colspan="4">No invoice lines found for this invoice.</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-menu appendTo="body" #menu [model]="items" [popup]="true" />
</p-card>
